import { makeObservable, observable, action, runInAction, toJS } from "mobx";
import api from "../modules/Admin/api";
import Constants from "../constants/Common";
import {
  ExpandableKeys,
  PerPageSettings,
  Searcher,
  StatusInfo,
  WithBooleanFlag,
} from "./core";
import { SearchRequest } from "../api/Types";

class RolesStore {
  rolesData = [];
  permissionsData = {};

  roleParamsRowKeys: ExpandableKeys = new ExpandableKeys();
  isShowAddForm = new WithBooleanFlag(false);
  rolesIsLoading = new WithBooleanFlag(false);
  permissionsIsLoading = new WithBooleanFlag(false);
  paginator = new PerPageSettings();
  roleStateStatus = new StatusInfo();
  search = new Searcher(["name", "description"]);

  constructor() {
    makeObservable(
      this,
      {
        rolesData: observable,
        getRolesList: action,
        deleteRole: action,
      },
      {
        deep: true,
      },
    );
  }

  getRolesList = async () => {
    this.rolesIsLoading.setTrue();

    try {
      const request: SearchRequest = {
        page: this.paginator.page,
        count: this.paginator.perPage,
        search: this.search.getSearch(),
      };
      const res = await api.getRoles(request);
      runInAction(() => {
        this.rolesData = res.data.items;
        this.paginator.updateMeta(res.data);
      });
    } catch (e) {
      console.log(e);
    } finally {
      this.rolesIsLoading.setFalse();
    }
  };

  getRolePermissions = async (roleId) => {
    this.permissionsIsLoading.setTrue();

    try {
      const res = await api.getRolePermissions(roleId);
      runInAction(() => {
        this.permissionsData[roleId] = res.data;
      });
    } catch (e) {
      console.log(e);
    } finally {
      this.permissionsIsLoading.setFalse();
    }
  };

  saveRole = async (values) => {
    this.roleStateStatus.resetStatus();

    try {
      const res = await api.saveRole(values);
      runInAction(() => {
        !values.id
          ? this.roleStateStatus.setStatus(Constants.requestStatuses.created)
          : this.roleStateStatus.setStatus(Constants.requestStatuses.updated);
        this.getRolesList();
      });
    } catch (e) {
      const valueError: string[] = e?.response?.data?.errors
        ? Object.values(e.response.data.errors)
        : [""];
      this.roleStateStatus.setDetails(valueError);
      this.roleStateStatus.setStatus(Constants.requestStatuses.error);
    }
  };

  cloneRole = async (values) => {
    this.roleStateStatus.resetStatus();
    try {
      const res = await api.cloneRole(values);
      runInAction(() => {
        this.roleStateStatus.setStatus(Constants.requestStatuses.created);
        this.getRolesList();
      });
    } catch (e) {
      this.roleStateStatus.setDetails(e);
      this.roleStateStatus.setStatus(Constants.requestStatuses.error);
    }
  };

  deleteRole = async (roleId) => {
    this.roleStateStatus.resetStatus();

    try {
      const res = await api.deleteRole(roleId);
      runInAction(() => {
        this.roleStateStatus.setStatus(Constants.requestStatuses.deleted);
        this.getRolesList();
      });
    } catch (e) {
      this.roleStateStatus.setDetails(e);
      this.roleStateStatus.setStatus(Constants.requestStatuses.error);
    }
  };
}

const roleStore = new RolesStore();
export default roleStore;
